export default __webpack_public_path__ + "static/media/homeBanner.f1c18367.jpg";